// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    noDataMessage: {
        id: 'bar-graph.no-data-message',
        defaultMessage: 'The data is empty or not valid.'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/intl.js